import React from "react";
import laravelLogo from "../assets/images/laravel-logo.png";
import reactLogo from "../assets/images/react-logo.png";

const Technology = () => {
    return (
        <div id="technology">
            <div className="tech-stack">
                <div className="jumbotron jumbotron-fluid tech-stack-jumbotron">
                    <div className="container p-4">
                        <div className="tech-stack-content">
                            <div className="row">
                                <div className="col-md-4 d-flex flex-column justify-content-center">
                                    <p className="tag">Tech That Drive Success</p>
                                    <h2>The modern stack we use to build <br/> what's next.</h2>
                                    <p>We stay ahead of the curve by combining proven frameworks with the
                                        latest advancements — including GenAI — to ship fast, scalable, and
                                        future-proof products for our clients.</p>
                                </div>
                                <div className="col-md-4 p-2">
                                    <div className="tech-stack-card bg-light p-4 d-flex align-items-start">
                                        <div>
                                            <img src={reactLogo} className="tech-stack-logo img-fluid" alt="Loading"/>
                                            <h4 className="pt-3">React &amp; Next.js</h4>
                                            <p>Blazing-fast, interactive and SEO-friendly user interfaces built
                                                with the component-based architecture of React and the power of
                                                Next.js — delivering the smooth experiences users expect today.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4 p-2">
                                    <div className="tech-stack-card bg-light p-4 d-flex align-items-start">
                                        <div>
                                            <img src={laravelLogo} className="tech-stack-logo img-fluid" alt="Loading"/>
                                            <h4 className="pt-3">PHP on Laravel</h4>
                                            <p>A trusted, secure framework for robust backends. Benefit from its
                                                vast ecosystem and extensive toolkit to create scalable,
                                                maintainable applications tailored to your business requirements.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 p-2">
                                    <div className="tech-stack-card bg-light p-4 d-flex align-items-start">
                                        <div>
                                            <h4 className="pt-3">Node.js &amp; Cloud</h4>
                                            <p>Real-time, high-performance backends and cloud-native deployment on
                                                AWS/GCP for reliability, observability, and effortless scaling.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 p-2">
                                    <div className="tech-stack-card bg-light p-4 d-flex align-items-start">
                                        <div>
                                            <h4 className="pt-3">Flutter &amp; React Native</h4>
                                            <p>Cross-platform mobile apps with near-native performance and a
                                                single codebase — launching faster on iOS and Android together.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 p-2">
                                    <div className="tech-stack-card bg-light p-4 d-flex align-items-start">
                                        <div>
                                            <h4 className="pt-3">GenAI &amp; LLM Integration</h4>
                                            <p>Smart chatbots, intelligent search, and automation powered by
                                                large language models to personalize experiences and cut manual work.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Technology;
